import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { IoLogoYoutube } from "react-icons/io";

const SocialMediaLinks = [
  { id: 1, icon: <FaFacebookF />, link: "https://www.facebook.com" },
  { id: 2, icon: <FaTwitter />, link: "https://www.twitter.com" },
  { id: 3, icon: <FaLinkedinIn />, link: "https://www.linkedin.com" },
  { id: 4, icon: <FiInstagram />, link: "https://www.instagram.com" },
  { id: 5, icon: <IoLogoYoutube />, link: "https://www.youtube.com" },
];

export default SocialMediaLinks;
